import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useCallback, useEffect, useRef, useState } from "react";
import { setColumnWidth } from "../../../helpers/cookieUtils";
import ListingHeader from "../listingHeader/ListingHeader";
import {
  Tooltip,
  TableCellLayout,
  Avatar,
  Popover,
  PopoverTrigger,
  PopoverSurface,
  makeStyles,
} from "@fluentui/react-components";
import HoverCard from "../../hoverCard/HoverCard";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import useNavigation from "../../../utils/useNavigation";
import {
  AttachementIcon,
  DeleteIcon,
  EditIcon,
  FlagIcon,
  MeatBallsMenuIcon,
  PendingDeleteIcon,
  RemindIcon,
} from "../../../modules/default-svg";
import {
  dateFormats,
  isValidDate,
  localDateFormatted,
  localDateToISODateString,
  utcToLocalDateString,
  dateOnlyFormatted
} from "../../../utils/systemSettings";
import userService from "../../../store/services/user.service";
import contactservice from "../../../store/services/contact.service";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { generalActions } from "../../../store/actions";
import CustomSelect from "../select/CustomSelect";
import Spin from "../spinner/Spin";
import {
  updateClientFlag,
  updateClientRequest,
  createClientRequest,
} from "../../../store/actions/clients.actions";
import {
  compareArrays,
  formatSequenceNumber,
  getDeletePermission,
  getEditPermission,
  sortColumnsByOrderlist,
} from "../../../helpers/utils";
import { useColumnConfig } from "./ColumnConfigProvider";
import { createSkeletonRows } from "./utils/tableUtils";

const EditInput = ({
  label,
  value,
  onChange,
  type,
  onBlur,
  dateFormat,
  table,
  clientId,
}) => {
  const isCreateRow = table.getState().creatingRow !== null;
  const [inputValue, setInputValue] = useState("");
  const [resources, setResources] = useState([]);

  const handleDateChange = (newDate) => {
    if (isValidDate(newDate)) {
      const newValue = localDateToISODateString(newDate);
      setInputValue(newValue);
      onChange(newValue);
    }
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const creatingRowState = table.getState().creatingRow;
      if (table?.options?.onCreatingRowSave && creatingRowState) {
        const currentValues = {
          ...creatingRowState.values,
        };
        table.options.onCreatingRowSave({
          values: currentValues,
          table,
        });
      }
    }
  };

  const searchHandler = (value) => {
    if (value === "") {
      setResources([]);
      return;
    }
    contactservice
      .searchContacts("Clients", clientId, "")
      .then((searchResults) => {
        const transformedArray = searchResults?.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setResources(transformedArray);
      })
      .catch(() => {
        setResources([]);
      });
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleSelectChange = (item) => {
    if (!item) return;
    const newValue = { id: item.value, name: item.label };
    setResources((prev) => [...prev, newValue]);
    handleInputChange(newValue);
  };

  if (type === "text") {
    return (
      <input
        placeholder={`Enter ${label}`}
        defaultValue={inputValue}
        type={type}
        onChange={(e) => handleInputChange(e.target.value)}
        className="Custom-Input"
        onBlur={onBlur}
        onKeyDown={handleKeyDown}
      />
    );
  }

  if (label === "Client Manager") {
    return isCreateRow ? (
      <input
        placeholder={`Enter ${label}`}
        defaultValue={inputValue}
        type={type}
        onChange={(e) => handleInputChange(e.target.value)}
        className="Custom-Input"
        onBlur={onBlur}
        onKeyDown={handleKeyDown}
      />
    ) : (
      <div className="d-flex align-items-center w-full max-w-md mx-auto">
        <CustomSelect
          searchText={searchHandler}
          SelectText="manager"
          CustomClass="ModalAvatarSearch CustomSelect"
          options={resources}
          value={value ? { label: value.name, value: value.id } : null}
          onChange={handleSelectChange}
          creatable={false}
          setCreated={handleSelectChange}
          handleBlur={onBlur}
          isDatatable
          selectWd="w-100"
          onKeyDown={handleKeyDown}
        />
      </div>
    );
  }

  return (
    <DatePicker
      selected={inputValue ? moment(inputValue).toDate() : null}
      onChange={handleDateChange}
      dateFormat={dateFormat}
      className="CustomDatePickerInput"
      onBlur={onBlur}
      popperPlacement="bottom-start"
      placeholderText={dateFormat}
      onKeyDown={handleKeyDown}
      popperClassName="CustomDatePickerPopper"
      showPopperArrow={false}
    />
  );
};

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const ClientTable = (props) => {
  const {
    columnsList,
    rowData,
    setIsCreate,
    searchHandler,
    tableName,
    handleColumnOrdering,
    dispatch,
    setPageNum,
    perPageItems,
    pagination,
    handleReminder,
    handleEdit,
    handleDelete,
    clientLoading,
    handleAddRow,
    handleCancelAddRow,
    setRowData,
    triggerSearch,
  } = props;
  const styles = useStyles();
  const [cols, setCols] = useState([]);
  const [rows, setRows] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const setting = JSON.parse(localStorage.getItem("settings"));
  const [editedRows, setEditedRows] = useState({});
  const tableContainerRef = useRef(null);
  const lastScrollTop = useRef(0);
  const selectRefs = useRef({});
  const { navigateTo } = useNavigation();
  const [editingHeader, setEditingHeader] = useState(null);
  const [headerValue, setHeaderValue] = useState("");
  const [columnSizing, setColumnSizing] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);
  const [popoverStates, setPopoverStates] = useState({});
  const [sorting, setSorting] = useState([]);
  const [isFetchingMore, setIsFetchingMore] = useState(false);

 const handlePopoverChange = (itemId, isOpen) => {
    setPopoverStates( isOpen ? { [itemId]: isOpen } : {});
  };
  const [colsList, setColumnsList] = useState([]);
  useEffect(() => {
    if (columnsList.length) {
      setColumnsList(columnsList);
    }
  }, [columnsList]);
  const handleHeaderDoubleClick = (columnId, currentHeader) => {
    setEditingHeader(columnId);
    setHeaderValue(currentHeader);
  };

  const handleHeaderSave = (columnId) => {
    if (!headerValue.trim()) {
      dispatch(
        generalActions.showToast({
          title: "Header name cannot be empty",
          type: "error",
        })
      );
      return;
    }

    const updatedColumnsDB = cols.map((col) => ({
      name: col.Label,
      customName: col.accessorKey === columnId ? headerValue : col.CustomName,
      order: col.Order,
      isVisible: col.Visibility,
    }));

    const payload = {
      Name: tableName,
      Columns: updatedColumnsDB,
    };

    userService
      .putUserLayoutRequest(payload)
      .then(() => {})
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title: "Error updating column header",
            type: "error",
          })
        );
      })
      .finally(() => {
        setColumnsList((prevCols) => {
          const newCols = prevCols.map((col) =>
            col.accessorKey === columnId
              ? { ...col, header: headerValue, customName: headerValue }
              : col
          );
          return newCols;
        });
      });

    setEditingHeader(null);
    setHeaderValue("");
  };

  const handleRedirect = (item) => {
    // Use navigation hook instead of localStorage
    navigateTo("Clients", item.id, item.name);
  };

  const handleFlag = (id, status) => {
    const newData = [...rowData];
    const index = newData.findIndex((item) => item.id === id);
    if (index !== -1) {
      newData[index].isFlagged = status;
    }

    setRowData(
      newData.sort((a, b) => {
        return b.isFlagged - a.isFlagged;
      })
    );
    dispatch(
      updateClientFlag({
        id: id,
        payload: [
          {
            op: "replace",
            path: "/IsFlagged",
            value: status,
          },
        ],
      })
    );
  };

  const fetchMoreData = useCallback(() => {
    if (!pagination?.HasNext || clientLoading || isFetchingMore) return;
    setIsFetchingMore(true);
    setPageNum(pagination.CurrentPage + 1);
  }, [pagination, clientLoading, isFetchingMore, setPageNum]);

  useEffect(() => {
    if (!clientLoading && isFetchingMore) {
      setIsFetchingMore(false);
    }
  }, [clientLoading, rowData.length]);

  const fetchMoreOnBottomReached = useCallback(
    (containerRefElement) => {
      if (!containerRefElement || clientLoading || !pagination?.HasNext) return;

      const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
      const scrolledToBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 50;
      const isScrollingDown = scrollTop > lastScrollTop.current;

      lastScrollTop.current = scrollTop;

      if (isScrollingDown && scrolledToBottom) {
        fetchMoreData();
      }
    },
    [fetchMoreData, clientLoading, pagination]
  );

  const throttledFetchMore = useCallback(
    (() => {
      let timeoutId;
      return (containerRefElement) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          fetchMoreOnBottomReached(containerRefElement);
        }, 100);
      };
    })(),
    [fetchMoreOnBottomReached]
  );

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const handleScroll = () => throttledFetchMore(container);
      container.addEventListener("scroll", handleScroll, { passive: true });
      return () => {
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [throttledFetchMore]);

  // Reset scroll position when search is triggered
    useEffect(() => {
      if (tableContainerRef.current && triggerSearch !== undefined) {
        tableContainerRef.current.scrollTop = 0;
        lastScrollTop.current = 0;
      }
    }, [triggerSearch]);
    
  const formatPayload = (payload) => {
    const formattedPayload = {};
    Object.keys(payload).forEach((key) => {
      if (key === "contractStartDate" || key === "contractEndDate") {
        formattedPayload[key] = payload[key]
          ? moment(payload[key]).format("YYYY-MM-DD")
          : null;
      } else {
        formattedPayload[key] = payload[key];
      }
    });
    return formattedPayload;
  };

  const handleSave = (rowId, payload) => {
    dispatch(
      updateClientRequest({
        id: rowId,
        type: "listing",
        payload,
      })
    );
    setEditedRows({});
  };

  const handleCreate = (payload) => {
    let finalPayload = new FormData();
    for (const key in payload) {
      if (payload[key] !== undefined && payload[key] !== null) {
        finalPayload.append(key, payload[key]);
      }
    }
    dispatch(createClientRequest({ finalPayload, perPageItems }));
  };

  const getSortingFunction = (col) => {
    switch (col.label) {
      case "Client":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.name || "").toLowerCase();
          const b = (rowB.original.name || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Sequence #":
        return (rowA, rowB, columnId) => {
          const a = rowA.original.sequenceNumber || 0;
          const b = rowB.original.sequenceNumber || 0;
          return a - b;
        };

      case "Client Manager":
        return (rowA, rowB, columnId) => {
          const a = (
            rowA.original.manager?.name ||
            rowA.original.manager?.email ||
            rowA.original.manager?.phone ||
            ""
          ).toLowerCase();
          const b = (
            rowB.original.manager?.name ||
            rowB.original.manager?.email ||
            rowB.original.manager?.phone ||
            ""
          ).toLowerCase();
          return a.localeCompare(b);
        };

      case "Industry":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.industry || "").toLowerCase();
          const b = (rowB.original.industry || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Status":
        return (rowA, rowB, columnId) => {
          const a = (rowA.original.status || "").toLowerCase();
          const b = (rowB.original.status || "").toLowerCase();
          return a.localeCompare(b);
        };

      case "Contract Start Date":
        return (rowA, rowB, columnId) => {
          const a = new Date(rowA.original.contractStartDate || 0);
          const b = new Date(rowB.original.contractStartDate || 0);
          return a.getTime() - b.getTime();
        };

      case "Contract End Date":
        return (rowA, rowB, columnId) => {
          const a = new Date(rowA.original.contractEndDate || 0);
          const b = new Date(rowB.original.contractEndDate || 0);
          return a.getTime() - b.getTime();
        };

      case "Creation Date":
        return (rowA, rowB, columnId) => {
          const a = new Date(rowA.original.dateCreated || 0);
          const b = new Date(rowB.original.dateCreated || 0);
          return a.getTime() - b.getTime();
        };

      default:
        return "alphanumeric";
    }
  };

  const getSortDescFirst = (col) => {
    const descFirstColumns = [
      "Contract Start Date",
      "Contract End Date",
      "Creation Date",
    ];
    return descFirstColumns.includes(col.label);
  };
  useEffect(() => {
    if (!colsList?.length && !rowData.length) return;

    const baseRows = [...rowData];
    
    if (isFetchingMore && pagination?.HasNext) {
      const skeletonRows = createSkeletonRows();
      setRows([...baseRows, ...skeletonRows]);
    } else {
      setRows(baseRows);
    }
  }, [rowData, isFetchingMore, pagination?.HasNext, colsList]);

  useEffect(() => {
    if (!colsList?.length && !rowData.length) return;

    const columnsOrder = colsList
      .filter((col) => col.isVisible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((item) => item.accessorKey);
    setColumnOrder(columnsOrder);

    const columns = colsList
      .filter((col) => col.isVisible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0))
      .map((col, index) => {
        return {
          Label: col.label,
          CustomName: col.customName,
          Order: col.order,
          Visibility: col.isVisible,
          accessorKey: col.accessorKey,
          header: col.header,
          enableHiding: true,
          enableColumnActions: false,
          grow: true,
          enableResizing: true,
          size: col.size,
          editVariant: col.columnType,
          enableGlobalFilter: true,
          enableEditing: col.accessorKey === "dateCreated" ? false : true,
          enableSorting: editingHeader === col.accessorKey ? false : true,
          sortingFn: getSortingFunction(col),
          sortDescFirst: getSortDescFirst(col),
          muiEditTextFieldProps: ({ cell, row }) => ({
            sx: {
              fontFamily: "Figtree-Regular",
              fontSize: "14px",
              padding: "0.5rem",
              maxHeight: "28px",
            },
            required: col.required || false,
            error: !!validationErrors?.[`${row.id}_${cell.column.id}`],
            helperText: validationErrors?.[`${row.id}_${cell.column.id}`],
            onFocus: () =>
              setValidationErrors({
                ...validationErrors,
                [cell.column.id]: undefined,
              }),
            inputRef: (el) => {
              if (col.columnType === "select") {
                selectRefs.current[`${row.id}_${cell.column.id}`] = el;
              }
            },
            onChange: (event) => {
              const newValue = event.target.value;
              setEditedRows((prev) => ({
                ...prev,
                [row.id]: {
                  ...prev[row.id],
                  [cell.column.id]: newValue,
                },
              }));
            },
            onBlur: (event) => {
              const value = event.target.value;
              const validationError =
                col.required && !value ? "Required" : undefined;
              setValidationErrors((prev) => ({
                ...prev,
                [`${row.id}_${cell.column.id}`]: validationError,
              }));
            },
          }),
          Cell: ({ cell, row }) => {
            const item = row.original;
            // Render skeleton for skeleton rows
            if (item.isSkeleton) {
              return (
                <div 
                  style={{
                    height: '20px',
                    background: 'linear-gradient(90deg, #e0e0e0 25%, #ECE7FD 50%, #e0e0e0 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 1.5s infinite',
                    borderRadius: '4px',
                    width: '100%'
                  }}
                />
              );
            }
            switch (col.label) {
              case "Client":
                return (
                  <div className="d-flex justify-content-between align-items-center inputWidth">
                    <div className="d-flex align-items-center inputWidth">
                      <Tooltip
                        positioning="before"
                        content={{
                          children: item.isFlagged ? "Unflag" : "Flag",
                          className: styles.tooltip,
                        }}
                        relationship="label"
                        withArrow
                      >
                        <span
                          className={`flag ${
                            item.isFlagged ? "flagActive" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleFlag(item.id, !item.isFlagged);
                          }}
                        >
                          <FlagIcon />
                        </span>
                      </Tooltip>
                      <span
                        className="d-flex w-full text-truncate"
                        onClick={() => handleRedirect(item)}
                      >
                        {item.attachementsCount > 0 && (
                          <div className="mr-1">
                            <AttachementIcon count={item.attachementsCount} />
                          </div>
                        )}
                        {item.isPendingDelete && (
                          <div className="mr-1">
                            <PendingDeleteIcon />
                          </div>
                        )}
                        {item.name}
                      </span>
                      <div className="meatballs-trigger">
                        <Popover
                          open={popoverStates[item.id]}
                          onOpenChange={(e,data) => handlePopoverChange(item.id, data.open || false)}
                          positioning="below-start"
                        >
                          <PopoverTrigger disableButtonEnhancement>
                            <TableCellLayout
                              media={<MeatBallsMenuIcon />}
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handlePopoverChange(
                                  item.id,
                                  !popoverStates[item.id]
                                );
                              }}
                            />
                          </PopoverTrigger>
                          <PopoverSurface
                            tabIndex={-1}
                            className="listingPopoverWrapper"
                          >
                            <div className="listingPopoverContent">
                              {getEditPermission("Client") && (
                                <div
                                  className="popItem"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleEdit(item);
                                    handlePopoverChange(
                                      item.id,
                                      !popoverStates[item.id]
                                    );
                                  }}
                                >
                                  <EditIcon />
                                  <p className="text-sm-400 ms-12">Edit</p>
                                </div>
                              )}
                              <div
                                className="popItem"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  handleReminder(item);
                                  handlePopoverChange(
                                    item.id,
                                    !popoverStates[item.id]
                                  );
                                }}
                              >
                                <RemindIcon />
                                <p className="text-sm-400 ms-12">Remind me</p>
                              </div>
                              {getDeletePermission("Client", item) && (
                                <div
                                  className="popItem"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handlePopoverChange(
                                      item.id,
                                      !popoverStates[item.id]
                                    );
                                    handleDelete(item);
                                  }}
                                >
                                  <DeleteIcon />
                                  <p className="text-sm-400 ms-12">Delete</p>
                                </div>
                              )}
                            </div>
                          </PopoverSurface>
                        </Popover>
                      </div>
                    </div>
                  </div>
                );
              case "Sequence #":
                return formatSequenceNumber("Client", item.sequenceNumber);
              case "Client Manager":
                return (
                  <>
                    {item.manager ? (
                      <TableCellLayout
                        media={
                          <HoverCard
                            HoverCardTrigger={
                              <Avatar
                                color="colorful"
                                name={
                                  item.manager?.name ||
                                  item.manager?.email ||
                                  item.manager?.phone
                                }
                                size={24}
                                image={{ src: "" }}
                              />
                            }
                            AvatarName={item.manager?.name || item.manager?.email || item.manager?.phone}
                            AvatarDesignation="Manager"
                            AvatarEmail={item.manager?.email}
                            AvatarPhone={item.manager?.phone}
                            AvatarIsExternal={true}
                            CanSendMessage={false}
                          />
                        }
                      >
                        {item.manager?.name ||
                          item.manager?.email ||
                          item.manager?.phone}
                      </TableCellLayout>
                    ) : (
                      item.manager?.name ||
                      item.manager?.email ||
                      item.manager?.phone
                    )}
                  </>
                );
              case "Industry":
                return item.industry;
              case "Status":
                return item.status;
              case "Contract Start Date":
                return item.contractStartDate
                  ? dateOnlyFormatted(setting, item.contractStartDate)
                  : "";
              case "Contract End Date":
                return item.contractEndDate
                  ? dateOnlyFormatted(setting, item.contractEndDate)
                  : "";
              case "Creation Date":
                return item.dateCreated
                  ? utcToLocalDateString(setting, item.dateCreated)
                  : "";
              default:
                return cell.getValue();
            }
          },
          Edit: ({ cell, row, table }) => {
            const value =
              editedRows[row.id]?.[cell.column.id] ??
              cell.getValue() ??
              row.original[cell.column.id] ??
              (col.columnType === "select" ? null : "");
            return (
              <EditInput
                label={col.header}
                value={value}
                onChange={(newValue) => {
                  if (row.id.startsWith("mrt-row-create")) {
                    table.setCreatingRow((prev) => ({
                      ...prev,
                      values: {
                        ...prev.values,
                        [cell.column.id]: newValue,
                      },
                    }));
                  } else {
                    setEditedRows((prev) => ({
                      ...prev,
                      [row.id]: {
                        ...prev[row.id],
                        [cell.column.id]: newValue,
                      },
                    }));
                  }
                }}
                onBlur={() => {
                  if (!row.id.startsWith("mrt-row-create")) {
                    const newValue = editedRows[row.id]?.[cell.column.id];
                    table.options.onEditingCellSave?.({
                      cell,
                      value: newValue,
                      row,
                      table,
                    });
                    table.setEditingCell(null);
                  }
                }}
                type={col.columnType}
                dateFormat={
                  col.columnType === "date"
                    ? setting.regionalSettings.dateFormat
                    : null
                }
                table={table}
                clientId={row.original.id}
              />
            );
          },
          Header: ({ column }) => {
            return editingHeader === column.id ? (
              <input
                value={headerValue}
                onChange={(e) => setHeaderValue(e.target.value)}
                onBlur={() => handleHeaderSave(column.id)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleHeaderSave(column.id);
                  }
                }}
                autoFocus
                className="header-edit-input"
                style={{
                  minWidth: column.getSize() - 60,
                }}
              />
            ) : (
              <span>{column.columnDef.header}</span>
            );
          },
        };
      });
    setCols((prevCols) => {
      if (JSON.stringify(prevCols) !== JSON.stringify(columns)) {
        return columns;
      }
      return prevCols;
    });

    const uniqueRows =
      rowData?.filter(
        (row, index, self) => index === self.findIndex((r) => r.id === row.id)
      ) || [];
    setRows((prevRows) => {
      if (JSON.stringify(prevRows) !== JSON.stringify(uniqueRows)) {
        return uniqueRows;
      }
      return prevRows;
    });
  }, [colsList, rowData, editingHeader, headerValue]);

  const table = useMaterialReactTable({
    columns: cols,
    data: rows,
    enableHiding: true,
    enableSorting: true,
    manualSorting: false,
    visibleInShowHideMenu: false,
    enablePagination: false,
    enableTopToolbar: true,
    enableGlobalFilter: true,
    enableStickyHeader: true,
    enableColumnFilterModes: true,
    enableColumnDragging: true,
    enableColumnOrdering: true,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    editDisplayMode: "cell",
    globalFilterFn: "contains",
    enableEditing: false,
    enableFilters: false,
    enableCreatingRow: true,
    createDisplayMode: "row",
    positionCreatingRow: "bottom",
    initialState: {
      density: "compact",
      showGlobalFilter: false,
      showColumnFilters: false,
      enableHiding: false,
      columnOrder: cols.map((col) => col.order),
    },
    state: {
      sorting,
      isLoading: rows.length === 0 && clientLoading,
      columnSizing,
      columnOrder,
      showLoadingOverlay: false,
      showProgressBars: false,
    },
    onSortingChange: setSorting,
    onCreatingRowCancel: () => {
      setValidationErrors({});
      handleCancelAddRow();
    },
    onCreatingRowSave: ({ values, table }) => {
      if (!values.name?.trim()) {
        dispatch(
          generalActions.showToast({
            title: "Name Field is Required",
            type: "error",
          })
        );
        return;
      }
      const payload = {
        Name: values.name,
        newManager: JSON.stringify({
          name: values?.manager,
          email: "",
          phone: "",
          notes: "",
        }),
        industry: values?.industry ?? "",
        status: values?.status ?? "",
        contractStartDate: values?.contractStartDate ?? "",
        contractEndDate: values?.contractEndDate ?? "",
      };
      handleCreate(payload);
      table.setCreatingRow(null);
    },
    onEditingRowCancel: () => {
      setValidationErrors({});
      setEditedRows({});
    },
    positionGlobalFilter: "left",
    onEditingCellSave: ({ cell, row }) => {
      const editedRow = editedRows[row.id];
      const newValue =
        editedRow?.[cell.column.id] !== undefined
          ? editedRow[cell.column.id]
          : cell.getValue();

      if (newValue === cell.getValue()) return; // Skip if no real change
      setRows((prevRows) =>
        prevRows.map((r, index) =>
          index === row.index ? { ...r, [cell.column.id]: newValue } : r
        )
      );

      // Remove the specific cell edit
      setEditedRows((prev) => {
        const updated = { ...prev };
        if (updated[row.id]) {
          delete updated[row.id][cell.column.id];
          if (Object.keys(updated[row.id]).length === 0) {
            delete updated[row.id];
          }
        }
        return updated;
      });

      const prePayload =
        cell.column.id === "manager"
          ? {
              ...row.original,
              manager: newValue,
              managerId: newValue?.id,
            }
          : {
              ...row.original,
              [cell.column.id]: newValue,
            };
      const payload = formatPayload(prePayload);
      handleSave(row.original.id, payload);
    },
    onColumnSizingChange: (updater) => {
      setColumnSizing((prev) => {
        const newSizing =
          typeof updater === "function" ? updater(prev) : updater;
        Object.entries(newSizing).forEach(([columnId, width]) => {
          setColumnWidth(tableName, columnId, width);
        });
        return newSizing;
      });
    },
    onColumnOrderChange: (updater) => {
      const newOrder = typeof updater === "function" ? updater() : updater;
      const neworderList = newOrder
        .filter((item) => item !== "mrt-row-spacer")
        .filter(Boolean);
      const areEqual = compareArrays(neworderList, columnOrder);
      if (areEqual) {
        return newOrder;
      }

      const sortedColumns = sortColumnsByOrderlist(colsList, neworderList);
      handleColumnOrdering(sortedColumns);
      setColumnOrder(neworderList);
      return neworderList;
    },
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        fontFamily: "Figtree-Medium",
        fontSize: "14px",
        padding: "1rem 0.5rem 1rem 1rem",
        backgroundColor: "#f8f7fc",
        color:"#342c82",
        height: "40px",
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "#ece8fd",
          "& .MuiDivider-root": {
            opacity: 1,
          },
          "& .MuiButtonBase-root": {
            opacity: 1,
          },
          fontWeight: 700,
        },
        position: "relative",
        "& .Mui-TableHeadCell-Content": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
        },
        "& .MuiTableSortLabel-root": {
          marginLeft: "8px",
          paddingTop: "3px",
          opacity: 0,
          "&:hover": {
            opacity: 1,
          },
        },
        "& .MuiDivider-root": {
          cursor: "col-resize",
          backgroundColor: "#342C82",
          opacity: 0,
        },
        "& .MuiButtonBase-root": {
          cursor: "grab",
          opacity: 0,
          "& .MuiSvgIcon-root": {
            path:{
              fill: "#342C82"
            }
          }
        },
      },
      onDoubleClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        handleHeaderDoubleClick(column.id, column.columnDef.header);
      },
    }),
    muiTopToolbarProps: {
      showColumnFilters: false,
      showGlobalFilter: true,
      enableHiding: false,
      sx: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        "& .MuiBox-root": {
          padding: 0,
          display: "flex",
          alignItems: "center",
        },
      },
    },
    renderTopToolbar: () => (
      <ListingHeader
        isHeader={true}
        parentType="Client"
        type="Client"
        btnLable="Add Client"
        searchedData={searchHandler}
        setIsCreate={() => setIsCreate(true)}
        rightPane={true}
        isCreatable={true}
        isSearchDisable={cols.length}
        handleCreateFunc={() => {
          handleAddRow();
          table.setCreatingRow(true);
        }}
        triggerSearch={triggerSearch}
      />
    ),
    renderBottomToolbarCustomActions: () => (
      <div className="bottom-toolbar-container">
        <div className="toolbar-content">
          {clientLoading || isFetchingMore ? (
            <div className="loading-indicator">
              <span>{`${!isFetchingMore ? 'Loading...' : 'Loading more data...'}`}</span>
            </div>
          ) : pagination?.TotalCount > 0 ? (
            <div className="data-info">
              <span className="data-text">
                Showing <strong>{rowData.length}</strong> of{" "}
                <strong>{pagination?.TotalCount || 0}</strong> total records
              </span>
            </div>
          ) : (
            <div className="data-info">
              <span className="data-text">No records Found</span>
            </div>
          )}
        </div>
      </div>
    ),
    muiBottomToolbarProps: {
      sx: {
        position: "absolute",
        bottom: 0,
        backgroundColor: "#f8f7fc",
        padding: "0.7rem 1rem",
        width: "100%",
        height: "38px",
      },
    },
    muiTableBodyProps: {
      sx: {
        fontFamily: "Figtree-Regular",
        fontSize: "13px",

        marginBottom: "66px",
        "& .MuiTableBody-Cell": {
          "&:hover": {
            backgroundColor: "#ece8fd15",
          },
        },
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        height: "32px",
        position: "relative",
        "&:hover": {
          backgroundColor: row.original.isSkeleton ? "transparent" : "#ece8fd15",
        },
        cursor: row.original.isSkeleton ? "default" : "pointer",
      },
      className: row.original.isSkeleton ? "" : "hoverable-row",
    }),
    muiTableContainerProps: ({ table }) => ({
      ref: tableContainerRef,
      sx: {
        height: `calc(100% - ${
          table.refs.topToolbarRef.current?.offsetHeight || 70
        }px)`,
        overflow: "auto",
        "&::-webkit-scrollbar": {
          height: "8px",
          width: "4px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#FFFFFF",
          borderRadius: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#342c82",
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: "#342c82",
          },
        },
      },
    }),
    muiTablePaperProps: {
      sx: {
        height: "100%",
      },
    },
    muiSkeletonProps: {
      height: 34,
      sx: {
        background:
          "linear-gradient(90deg, #e0e0e0 25%, #ECE7FD 50%, #e0e0e0 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite",
        "@keyframes shimmer": {
          "0%": {
            backgroundPosition: "200% 0",
          },
          "100%": {
            backgroundPosition: "-200% 0",
          },
        },
      },
    },
    muiTableBodyCellProps: ({ cell, column, table }) => ({
      sx: {
        fontFamily: "Figtree-Regular",
        fontSize: "13px",
        padding: "0.5rem 1rem",
        position: "relative",
        overflow: "visible",
        "&:focus": {
          outline: "none",
        },
        "&:hover": {
          fontFamily: "Figtree-Medium",
          fontWeight: "bold",
        },
      },
    }),
    renderEmptyRowsFallback: () => {
      return clientLoading ? (
        <div className="d-flex justify-content-center">
          <Spin />
        </div>
      ) : rows.length === 0 ? (
        <div className="flex-grow flex items-center justify-center p-4">
          <div className="h-full flex flex-col items-center justify-center min-h-[400px] p-8">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="65"
              height="64"
              viewBox="0 0 65 64"
              fill="none"
              className="mb-4"
            >
              <path
                d="M6.9002 21.6008C6.9002 16.7407 10.8401 12.8008 15.7002 12.8008H49.3002C54.1603 12.8008 58.1002 16.7407 58.1002 21.6008V42.4008C58.1002 47.2609 54.1603 51.2008 49.3002 51.2008H32.8884L27.8968 46.2092C28.7964 44.3293 29.3002 42.2239 29.3002 40.0008C29.3002 32.0479 22.8531 25.6008 14.9002 25.6008C11.94 25.6008 9.18835 26.494 6.9002 28.0257V21.6008ZM14.9002 51.2008C17.416 51.2008 19.7381 50.3713 21.6079 48.9708L29.7688 57.132C30.3936 57.7569 31.4067 57.7569 32.0315 57.1321C32.6564 56.5072 32.6564 55.4942 32.0316 54.8693L23.8706 46.708C25.2708 44.8384 26.1002 42.5164 26.1002 40.0008C26.1002 33.8152 21.0858 28.8008 14.9002 28.8008C8.71461 28.8008 3.7002 33.8152 3.7002 40.0008C3.7002 46.1864 8.71461 51.2008 14.9002 51.2008ZM14.9002 48.0008C10.4819 48.0008 6.9002 44.4191 6.9002 40.0008C6.9002 35.5825 10.4819 32.0008 14.9002 32.0008C19.3185 32.0008 22.9002 35.5825 22.9002 40.0008C22.9002 44.4191 19.3185 48.0008 14.9002 48.0008Z"
                fill="#342C82"
              />
            </svg>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              No data currently available!
            </h3>
            <p className="text-gray-600 text-center max-w-md">
            New entries will appear here once created.
            </p>
          </div>
        </div>
      ) : null;
    },
    muiLinearProgressProps: {
      sx: {
        height: "4px",
        backgroundColor: "#cfc9ff", 
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-bar1Indeterminate": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-bar2Indeterminate": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-barColorPrimary": {
          backgroundColor: "#342c82",
        },
        "& .MuiLinearProgress-colorPrimary": {
          backgroundColor: "#cfc9ff",
        },
        "& .MuiLinearProgress-colorSecondary": {
          backgroundColor: "#cfc9ff",
        },
        "& .MuiLinearProgress-barColorSecondary": {
          backgroundColor: "#342c82",
        },
      },
    },
  });

  return <MaterialReactTable table={table} />;
};

export default ClientTable;
